import z from "zod";

export enum CollectionCompletedState {
  completed = "complete",
  not_completed = "not_complete",
}

export const collectionCompletedStateEnum = z.enum(CollectionCompletedState);
